import { FC, useState, useEffect } from 'react';
import { AutocompleteInput, AutocompleteOption } from '@carcareers/components';
import { usePayment } from '@carcareers/hooks';

interface PaymentProfileSelectProps {
  name: string;
}

export const PaymentProfileSelect: FC<PaymentProfileSelectProps> = ({ name }) => {
  const { getCustomerProfile } = usePayment();
  const [options, setOptions] = useState<AutocompleteOption[]>([]);

  useEffect(() => {
    const { data, isLoading } = getCustomerProfile;

    if (!isLoading && data) {
      const paymentProfiles = data?.profile?.paymentProfiles?.map((profile) => ({
        label: `${profile.payment.creditCard.cardNumber.substring(4)} - ${profile.payment.creditCard.cardType}`,
        value: profile.customerPaymentProfileId,
      }));

      setOptions(paymentProfiles);
    }
  }, [getCustomerProfile]);

  return <AutocompleteInput options={options} name={name} label="Payment Profile" />;
};
